// import React from 'react';
import RoutesAll from './routes'
import './App.css'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { InviteLanding } from './components/InviteLanding'

function App() {
  return (
    <>
      <InviteLanding />
      <ToastContainer icon={false} autoClose={2000} hideProgressBar />
      <RoutesAll />
    </>
  )
}

export default App
